@if (notExisting()) {
  <p i18n>This page does not exist!</p>
  <p>
    <span i18n>Go back to the </span>
    <a class="alg-link base-color" routerLink="/" i18n>home page</a>
  </p>
} @else {
  <alg-loading />
}

